/* eslint-disable jsx-a11y/anchor-is-valid */
import { AccessTime, Done, DoneAll } from '@material-ui/icons';
import { format, isSameDay, parseISO } from "date-fns";
import xlsx from "json-as-xlsx";
import React from 'react';
import { toast } from "react-toastify";
import { KTSVG } from '../../../_metronic/helpers';
import api from "../../services/api";

type Props = {
    className: string
    relatoryData: any
}

function formatDateCorrect(date1: any, date2: any) {
    if (date1 === undefined) { if (date2 === undefined) { return new Date() } else { return date2 } }
    const x = new Date(date1);
    const y = new Date(date2);
    return x <= y ? date2 : date1;
};

const translateRelatory = {
    value: (obj: any) => {
        var translateValue: any[] = []
        obj.map((value: any) => {
            const translate = value;
            let formatedStatus: string = "";
            const currentStatus = String(translate['status']).toLowerCase();
            switch (currentStatus) {
                case "error":
                    formatedStatus = "Erro ao enviar";
                    break;
                case "blacklist":
                    formatedStatus = "Bloqueado";
                    break;
                case "answered":
                    formatedStatus = "Respondido";
                    break;
                case "sent":
                    formatedStatus = "Enviado";
                    break;
                default:
                    formatedStatus = String(translate.validationStatus) == 'validated' ? "Pendente" : "Não enviado";
                    break;
            }
            translate.status = formatedStatus;

            if (translate.validationStatus == 'notValidated') translate.validationStatus = 'Não Validado';
            if (translate.validationStatus == 'validated') translate.validationStatus = 'Validado';
            if (translate.validationStatus == 'invalid') translate.validationStatus = 'Inválido';
            if (translate.validationStatus == 'duplicated') translate.validationStatus = 'Duplicado';

            var typeMessage = translate.message_sent
            if (typeMessage === 'undefinedForUser') { translate.message_sent = 'Arquivo' }
            translateValue.push(translate)
        })
        return translateRelatory.object(translateValue);
    },
    object: (obj: any[]) => {
        var translateObj: any[] = [];
        obj.map((map) => {
            const obj = map;
            obj['Nome'] = obj['name'];
            delete obj['name'];
            obj['Número'] = obj['number'];
            obj['Número Validado'] = obj['formattedNumber'];
            delete obj['number'];
            obj['Mensagem'] = obj['message_sent'];
            delete obj['message_sent'];
            obj['Data'] = format(parseISO(formatDateCorrect(obj.updatedAt, obj.createdAt)), "dd/MM/yyyy");
            obj['Horario'] = format(parseISO(formatDateCorrect(obj.updatedAt, obj.createdAt)), "HH:mm");
            delete obj['updatedAt'];
            obj['StatusValidação'] = obj['validationStatus'];
            obj['Status'] = obj['status'];
            obj['Nome da Campanha'] = obj['campaignName'];

            translateObj.push(obj)
        })
        return translateObj;
    }
}

function exportRelatory(dataExport: any) {
    var relatoryComplete = translateRelatory.value(dataExport)

    let data = [{
        sheet: "Relatório",
        columns: [
            { label: "Nome", value: "Nome" },
            { label: "Número", value: "Número" },
            { label: "Número Validado", value: "Número Validado" },
            { label: "Nome da Campanha", value: "Nome da Campanha" },
            { label: "Mensagem", value: "Mensagem" },
            { label: "Data", value: "Data" },
            { label: "Horario", value: "Horario" },
            { label: "StatusValidação", value: "StatusValidação" },
            { label: "Status", value: "Status" },
        ],
        content: relatoryComplete,
    }]

    let settings = {
        fileName: "Relatório",
    }

    xlsx(data, settings)
}

const widgetTableRelatory: React.FC<Props> = ({ className, relatoryData }) => {
    const parsedRelatoryData = JSON.parse(relatoryData);
    
    var formating = (values: any) => {
        var data: any[] = [];
        values['lastMessageAndStatus'].forEach((contato: any) => {
            var returned = {
                id: contato.id,
                name: contato.name,
                number: contato.number,
                formattedNumber: contato.formattedNumber,
                message_sent: contato.message_sent,
                status: contato.status,
                validationStatus: contato.validationStatus,
                updatedAt: formatDateCorrect(contato.updatedAt, contato.createdAt),
                campaignName: parsedRelatoryData?.campaign?.name || ""
            }
            data.push(returned);
        });
        return data;
    }
    
    var relatorio = formating(parsedRelatoryData);

    const RenderStatus = (dados: any) => {
        const currentStatus = String(dados.status).toLowerCase();
        let formatedStatus: string = "";
        let className = "badge fs-7 fw-bold";

        switch (currentStatus) {
            case "error":
                formatedStatus = "Erro ao enviar";
                className += " badge-light-danger";
                break;
            case "blacklist":
                formatedStatus = "Bloqueado";
                className += " badge-light-danger";
                break;
            case "answered":
                formatedStatus = "Respondido";
                className += " badge-light-primary";
                break;
            case "sent":
                formatedStatus = "Enviado";
                className += " badge-light-success";
                break;
            default:
                formatedStatus = String(dados.validationStatus).toLowerCase() == 'validated' ? "Pendente" : "Não enviado";
                className += " badge-light-info";
                break;
        }
        return (<span id={`${dados.id}`} className={className}>{formatedStatus}</span>);
    }

    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>Relatório Completo - Envio</span>
                </h3>
                <div className='card-toolbar'>
                    <button
                        className='btn btn-sm btn-light-primary'
                        onClick={() => { exportRelatory(relatorio) }}
                    >
                        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                        Exportar Relatório
                    </button>
                </div>
            </div>
            
            <div className='card-body py-3' style={{ 
                overflow: 'auto',
                maxHeight: '25rem',
                position: 'relative'
            }}>
                {/* Tabela com cabeçalho fixo */}
                <div style={{
                    position: 'relative',
                    overflow: 'auto',
                    height: '100%'
                }}>
                    <table id="relatoryTable" className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4' style={{
                        width: '100%',
                        borderCollapse: 'separate',
                        borderSpacing: 0
                    }}>
                        {/* Cabeçalho fixo */}
                        <thead style={{ 
                            position: 'sticky',
                            top: 0,
                            zIndex: 1000,  // Valor muito alto para garantir prioridade
                            backgroundColor: '#f8f9fa',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                            <tr className='fw-bolder text-muted'>
                                {['Nome do Contato', 'Número do Contato', 'Número Válidado', '	Ultima Mensagem Trocada', 
                                'Ultima Atualização', 'Horário', 'Status Validação', 'Status'].map((header, index) => (
                                    <th key={index} style={{ 
                                        backgroundColor: 'inherit',
                                        position: 'sticky',
                                        top: 0
                                    }}>
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        
                        <tbody style={{ position: 'relative', zIndex: 1 }}>
                            {relatorio.map((dados) => (
                                <tr key={dados.id} style={{ backgroundColor: '#fff' }}>
                                    <td>
                                        <div className='d-flex align-items-center'>
                                            <div className='d-flex justify-content-start flex-column'>
                                                <span className='text-dark fw-bolder d-block fs-6'>
                                                    {dados.name}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bolder d-block fs-6'>
                                            {dados.number}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bolder d-block fs-6'>
                                            {dados.formattedNumber}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bolder d-block fs-6'>
                                            {dados.message_sent == 'undefinedForUser' ? (
                                                <div title='Esta campanha tem um arquivo' style={{ display: 'flex', marginTop: '10px' }}>
                                                    Arquivo
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-zip" viewBox="0 0 16 16">
                                                        <path d="M5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.11 0l-.929-.62a1 1 0 0 1-.415-1.074L5 8.438V7.5zm2 0H6v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.929-.62-.4-1.598A1 1 0 0 1 7 8.438V7.5z" />
                                                        <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1h-2v1h-1v1h1v1h-1v1h1v1H6V5H5V4h1V3H5V2h1V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
                                                    </svg>
                                                </div>
                                            ) : dados.message_sent}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bolder d-block fs-6'>
                                            {dados.updatedAt &&
                                                <>
                                                    {isSameDay(parseISO(dados.updatedAt), new Date()) ? (
                                                        <>Hoje</>
                                                    ) : (
                                                        <>{format(parseISO(dados.updatedAt), "dd/MM/yyyy")}</>
                                                    )}
                                                </>
                                            }
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bolder d-block fs-6'>
                                            {dados.updatedAt &&
                                                <>{format(parseISO(dados.updatedAt), "HH:mm")}</>
                                            }
                                        </span>
                                    </td>
                                    <td>
                                        {dados.validationStatus == 'notValidated' && <span className="badge badge-light-info fs-7 fw-bold">Não Validado</span>}
                                        {dados.validationStatus == 'validated' && <span className="badge badge-light-success fs-7 fw-bold">Validado</span>}
                                        {dados.validationStatus == 'invalid' && <span className="badge badge-light-danger fs-7 fw-bold">Inválido</span>}
                                        {dados.validationStatus == 'duplicated' && <span className="badge badge-light-danger fs-7 fw-bold">Duplicado</span>}
                                    </td>
                                    <td>
                                        {/* <div className='text-end' id={`div_of_${dadovs.id}`}> */}
                                            {RenderStatus(dados)}
                                        {/* </div> */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default widgetTableRelatory;